import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { formatDate, Translate } from '../../../../shared/LanguageService';

type BookingInfoLabels = {
    bookingInfoTime: string;
    bookingInfoPhotographer: string;
};

type ExternalProps = {
    selectedDay: string;
    selectedDate: Date;
    photographerName: string;
    startTime: Date;
    endTime: Date;
    showBookingInfo: boolean;
};

type BookingInfoProps = {
    labels: BookingInfoLabels;
} & ExternalProps;

const SelectedDateTextStyling = {
    fontFamily: 'Roboto',
    fontWeight: 700,
    fontSize: '12px',
    textTransform: 'capitalize',
    color: 'rgba(61,99,129)',
    lineHeight: '19px'
};

const BookingInfoTextStyling = {
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '12px',
    color: 'rgba(61,99,129)'
};

const BookingInfo = ({
    selectedDay,
    selectedDate,
    labels,
    photographerName,
    startTime,
    endTime,
    showBookingInfo
}: BookingInfoProps) => {
    let formattedSelectedDate = selectedDate
        ? formatDate(new Date(selectedDate), 'dd MMMM yyyy')
        : null;
    let formattedStartTime = startTime ? formatDate(new Date(startTime), 'kk' + ':' + 'mm') : null;
    let formattedEndTime = endTime ? formatDate(new Date(endTime), 'kk' + ':' + 'mm') : null;

    return showBookingInfo ? (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '71px',
                width: '100%',
                minWidth: '150px',
                maxWidth: '217px',
                border: '1px solid #2196F3',
                borderRadius: '4px',
                padding: '6px',
                margin: '12px',
                whiteSpace: 'noWrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis [..]'
            }}
        >
            <Box sx={{ margin: 'auto' }}>
                <Typography sx={SelectedDateTextStyling}>
                    {selectedDay}, {formattedSelectedDate}
                </Typography>
                {startTime != null ? (
                    <Typography sx={BookingInfoTextStyling}>
                        {labels.bookingInfoTime} {formattedStartTime} - {formattedEndTime}
                    </Typography>
                ) : null}
                {photographerName != null ? (
                    <Typography sx={BookingInfoTextStyling}>
                        {labels.bookingInfoPhotographer} {photographerName}
                    </Typography>
                ) : null}
            </Box>
        </Box>
    ) : (
        <Box
            sx={{
                minHeight: '71px',
                minWidth: '150px',
                maxWidth: '217px',
                margin: '12px'
            }}
        />
    );
};

const BookingInfoTranslationLayer = (props: ExternalProps) => {
    let labels: BookingInfoLabels = {
        bookingInfoTime: Translate('orders/list/bookings-calendar/booking-info-time'),
        bookingInfoPhotographer: Translate(
            'orders/list/bookings-calendar/booking-info-photographer'
        )
    };

    return <BookingInfo {...props} labels={labels} />;
};
export default BookingInfoTranslationLayer;
